import { type InstallmentOffer } from 'src/types/widget-offers';

import { getIsLimitedRamadanOffer } from '../components/long-term-content/utils';
import { type CurrencyType } from '../types/currency';

// this function is used for supporting old subvention campaigns (with isLimitedTimeOffer but without subventionCampaignId)
export const getLongestSubventionPlan = (
  installments: readonly InstallmentOffer[],
  currency: CurrencyType
): InstallmentOffer | undefined => {
  const subventionPlans = installments.filter(
    (f) =>
      (f.isLimitedTimeOffer && !f.subventionCampaignId) ||
      getIsLimitedRamadanOffer({
        paymentsCount: f.paymentsCount,
        serviceFeePercent: f.service_fee_percentage,
        serviceFeePolicy: f.serviceFeePolicy,
        currency,
      })
  );
  const sortedSubventionPlans = subventionPlans.sort(
    (a, b) => b.paymentsCount - a.paymentsCount
  );

  return sortedSubventionPlans[0];
};
